
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 19H2.643C1.735 19 1 18.105 1 17V3c0-1.105.735-2 1.643-2H13.32c.908 0 1.643.895 1.643 2v6.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 14.224c.156-.455.402-.884.766-1.247a3.336 3.336 0 015.287.764","stroke":"#3084B9","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.196 16.931a3.336 3.336 0 005.287.764c.364-.364.613-.792.769-1.247","stroke":"#D07D01","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.477 16.93h-1.474v1.475","stroke":"#D07D01","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.773 13.74h1.474v-1.474","stroke":"#3084B9","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.714 6.25h5.5M5.714 10.25h2.5"}})])
          )
        }
      }
    